<template>
  <div class="search_box">
    <div class="search_header">
      <div class="search_ipt">
        <input
          type="text"
          placeholder="搜索公司"
          v-model="key"
          @input='inputFun'
        />
      </div>
    </div>
    <div class="search_main">
      <span v-if="lists.length > 0" class="end_title">搜索结果</span>
      <template v-if="lists.length > 0">
        <div class="search_item" v-for="(item,index) in lists" :key="index" @click="backPage(item)">
          <span class="item_title">{{item.companyName}}</span>
        </div>
      </template>
    </div>
    <!-- 搜索结果显示 -->
    <span class="search_status" v-if="searchEnd == '1' && key.length != '0'">找不到与“{{key}}”匹配的内容</span>
    <div class="search_status2" v-if="searchEnd == '2' && key.length != '0'">
      <span>正在搜索...</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  getCompanyList
} from "../../utils/api";
import util from "../../utils/util";
import storage from "../../utils/storage";
let timer = ''
export default {
  watch: {
    searchData: function() {
      this.getCompanyList();
    }
  },
  data() {
    return {
      searchEnd: 0, //搜索结果状态
      key: "", //input值
      lists: []
    };
  },
  activated() {
    this.getData();
  },
  components: {},
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  methods: {
    getData() {
      if(!this.key ||this.key.length==0){  //有了关键字再搜索
          return;
      }
      let that = this;
      let params = {
        marketId: this.common.marketInfo.id,
        userId: this.common.userId,
        companyName: this.key,
        pageNo: 1,
        pageSize: 100
      };
      util.showLoading("加载中...");
      getCompanyList(params).then(res => {
        console.log(res);
        util.hideLoading();
        if (res.body.companyList.length > 0) {
          that.searchEnd = 0;
          that.lists = res.body.companyList;
        } else {
          that.searchEnd = 1;
        }
      });
    },
    backPage(item){
      storage.set("companyData",JSON.stringify(item))
      this.$router.go(-1)
    },
    inputFun(){//键盘输入时触发input事件
      clearTimeout(timer);
      var that = this;
      that.lists = []
      if (that.key.length == 0) {//如果输入框为空
        that.searchEnd = 0
      }else{
        this.searchEnd = 2
        timer = setTimeout(function(){
          that.getData();
        },800)
      }
    },
  }
};
</script>
<style lang="less" scoped>
.search_box {
  background: #fff;
}
.search_header {
  width: 100%;
  height: 100px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
}
.search_ipt {
  height: 68px;
  background: #f4f4f4;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  margin: 16px 28px;
}
.search_ipt input {
  background: transparent url("../../assets/images/search.png") 14px 12px no-repeat;
  background-size:44px 44px;
  font-size: 28px;
  color: #333;
  height: 68px;
  padding-left:74px;
  flex:1;
}
.search_main {
  margin-top: 100px;
  background: #fff;
}
.end_title {
  display: block;
  background: #f8f8f8;
  padding-left: 28px;
  font-size: 28px;
  color: #999;
  height: 68px;
  line-height: 68px;
}
.search_item {
  padding: 0 28px;
  border-bottom: 2px solid #eaeaea;
}
.item_title {
  font-size: 28px;
  color: #333;
  line-height: 100px;
}
.com {
  display: flex;
  flex-direction: row;
}
.com_left {
  margin-right: 28px;
  color: #999;
  font-size: 24px;
  line-height: 34px;
}
.com_right {
  flex: 1;
  color: #333;
  font-size: 24px;
  line-height: 34px;
}
/*search_status*/
.search_status {
  display: block;
  text-align: center;
  font-size: 28px;
  line-height: 40px;
  margin: 44px auto;
  color: #999;
}
.search_status2 {
  display: flex;
  text-align: center;
  margin: 30px auto;
  justify-content: center;
}
.search_status2 img {
  display: block;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  margin-top: 6px;
}
.search_status2 text {
  font-size: 28px;
  line-height: 40px;
  color: #888;
}
</style>
